module.exports = __webpack_public_path__ + "img/gadgets_data_normal@3x.ec977a65.png";